import {initShuffle} from "../../utils/_shuffle";
import AcfHelper from "../../_acf";

AcfHelper.handleInit("masonry", () => {
    initShuffle(".js-shuffle-masonry");
});
